import React from 'react';
import './PayNow.css'
import { paynow } from '../../../images/images';
import { Button } from 'unified-ui-components-library';

const PayNow = () => {
    const gotoPaymentPage = () => {
        const link = document.createElement('a')
        link.target = "_blank"
        link.href = "http://w.maxlife.in/llU4Tv"
        link.click()
    }
    return (<div className='paynow-cntnr' >
        <div className='paynow-header' >
            <div className='paynow-img-cntnr' >
                <img className='paynow-img' src={paynow} alt="" />
            </div>
        </div>
        <div className="policy-heading-cntnr paynow-heading" >
            <p className="heading-text text-center">
                ULIP Continuance Scheme
            </p>
            <p className='sub-heading-text text-center paynow-sub-heading'>
                We acknowledge your request to utilise your due premium from the Total Accumulated Fund Value in excess of premium paid of your Axis Max Life Policy number
            </p>
        </div>
        <div className="partition-line"></div>
        <div className="policyNumber-btn paynow-btn">
            <Button
                onClick={gotoPaymentPage}
                buttonType="primary"
                size='default'
            >
                Pay Now
            </Button>
        </div>
    </div>
    );
}

export default PayNow;